import { render } from "./CarRentalBilling.vue?vue&type=template&id=8396f370&scoped=true"
import script from "./CarRentalBilling.vue?vue&type=script&lang=js"
export * from "./CarRentalBilling.vue?vue&type=script&lang=js"

import "./CarRentalBilling.vue?vue&type=style&index=0&id=8396f370&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8396f370"]])

export default __exports__